
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.554 11.095l-1.89-.709-3.412 1.285a3.78 3.78 0 01-1.389.251c-.473 0-.945-.088-1.388-.25l-3.412-1.286-1.89.71a.494.494 0 00-.326.487c0 .088.03.369.325.487l5.672 2.142c.65.25 1.388.25 2.038 0l5.672-2.142a.494.494 0 00.325-.487c0-.089-.03-.37-.325-.488z","fill":"#fff"}}),_c('path',{attrs:{"d":"M14.554 7.565l-1.89-.709-3.412 1.285a3.78 3.78 0 01-1.389.251 4.05 4.05 0 01-1.388-.25L3.063 6.855l-1.89.71a.494.494 0 00-.326.487c0 .088.03.369.325.487l5.672 2.142c.65.25 1.388.25 2.038 0l5.672-2.142a.494.494 0 00.325-.487c0-.09-.03-.37-.325-.488z","fill":"#fff"}}),_c('path',{attrs:{"d":"M1.173 5.025l5.672 2.141c.65.251 1.388.251 2.038 0l5.672-2.141a.505.505 0 00.325-.488c0-.088-.03-.369-.325-.487L8.883 1.908a2.852 2.852 0 00-2.038 0L1.173 4.05a.494.494 0 00-.325.487c0 .074.03.37.325.488z","fill":"#fff"}})])
          )
        }
      }
    